/*
  "Laat het me weten" bij een uitverkocht product.

  Gaat naar Klaviyo's back-in-stock koppeling. Die hangt aan de variant en niet
  aan een lijst: Klaviyo weet daardoor zelf wanneer de voorraad bij Shopify weer
  boven nul komt en verstuurt dan het bericht. Wij hoeven niets bij te houden.

  Net als bij de nieuwsbrief is dit een gewoon formulier zonder eigen actie.
  Shopify's eigen formulieren krijgen reCAPTCHA mee, en dat script verstuurt ze
  zelf — waarmee het onderscheppen hier zinloos zou zijn.
*/
class BackInStock {
  constructor(root) {
    this.root = root;

    const config = root.querySelector('[data-notify-config]');
    const form = root.querySelector('form');
    if (!config || !form) return;

    try {
      this.config = JSON.parse(config.textContent);
    } catch (error) {
      return;
    }

    if (!this.config.key || !this.config.variant) {
      console.info('Voorraadmelding: Klaviyo onvolledig ingesteld.', this.config);
      return;
    }

    this.form = form;
    this.ok = root.querySelector('[data-notify-ok]');
    this.error = root.querySelector('[data-notify-error]');
    this.button = form.querySelector('[type="submit"]');

    form.addEventListener('submit', (event) => this.submit(event));
  }

  async submit(event) {
    event.preventDefault();

    const field = this.form.querySelector('[type="email"]');
    if (!field.checkValidity()) {
      field.reportValidity();
      return;
    }

    this.button.disabled = true;
    this.hide();

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.config.key)}`,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            revision: '2024-10-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: field.value.trim() } } },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    /*
                      Zo heet een Shopify-variant binnen Klaviyo's catalogus.
                      Die opmaak komt van hun eigen koppeling; een kaal
                      variant-id wordt niet herkend.
                    */
                    id: `$shopify:::$default:::${this.config.variant}`,
                  },
                },
              },
            },
          }),
        }
      );

      if (!response.ok) throw new Error(String(response.status));

      this.form.reset();
      this.root.classList.add('product__notify--done');
      this.show(this.ok);
    } catch (error) {
      console.error('Voorraadmelding mislukt:', error);
      this.show(this.error);
    } finally {
      this.button.disabled = false;
    }
  }

  hide() {
    if (this.ok) this.ok.hidden = true;
    if (this.error) this.error.hidden = true;
  }

  show(element) {
    this.hide();
    if (element) element.hidden = false;
  }
}

document.querySelectorAll('[data-notify]').forEach((root) => new BackInStock(root));
